/**
 * Extracted from workshop-booking.js initWorkshopBooking.
 * Init passes a scope object S; this file rebinds those names so the moved
 * body stays byte-for-byte the same. Loaded (defer) before workshop-booking.js.
 */
(function (global) {
  if (global.WorkshopBookingCart) return;
  global.WorkshopBookingCart = {
    attach: function (S) {
      if (!S) return;
      var wbUrlHasWizardDeepLink = S.wbUrlHasWizardDeepLink;
      var __WB_WAITLIST_API_URL__ = S.__WB_WAITLIST_API_URL__;
      var wbDiag = S.wbDiag;
      var __WBU = S.__WBU;
      var wbNormalizeEventStatus = S.wbNormalizeEventStatus;
      var wbEventCapacityRemaining = S.wbEventCapacityRemaining;
      var wbGetEventStatus = S.wbGetEventStatus;
      var wbExtractEventStatusRaw = S.wbExtractEventStatusRaw;
      var wbEventLookupKeys = S.wbEventLookupKeys;
      var wbBuildEventStatusLookup = S.wbBuildEventStatusLookup;
      var wbLookupEventStatus = S.wbLookupEventStatus;
      var wbIsDisplayStatusBookable = S.wbIsDisplayStatusBookable;
      var wbResolveEventStatus = S.wbResolveEventStatus;
      var wbIsEventSoldOut = S.wbIsEventSoldOut;
      var showSoldOutCapacityModal = S.showSoldOutCapacityModal;
      var wbIsEventBookable = S.wbIsEventBookable;
      var wbShouldHideEvent = S.wbShouldHideEvent;
      var wbPerf = S.wbPerf;
      var __WB_lastHandledPlaceFp = S.__WB_lastHandledPlaceFp;
      var STATE_NAME_TO_CODE = S.STATE_NAME_TO_CODE;
      var normalizeStateCode = S.normalizeStateCode;
      var WB_CATALOG_REGION_NAME_TO_CODE = S.WB_CATALOG_REGION_NAME_TO_CODE;
      var parseCityStateFromFormattedAddress = S.parseCityStateFromFormattedAddress;
      var getPlaceDisplayLabel = S.getPlaceDisplayLabel;
      var _lastPlaceSelectMs = S._lastPlaceSelectMs;
      var onPlaceSelect = S.onPlaceSelect;
      var ensureDocPlaceListeners = S.ensureDocPlaceListeners;
      var applyWizardPlaceAutocompleteChrome = S.applyWizardPlaceAutocompleteChrome;
      var applyPlaceAutocompleteLightTheme = S.applyPlaceAutocompleteLightTheme;
      var ensurePlaceListeners = S.ensurePlaceListeners;
      var wbSheetBodyEl = S.wbSheetBodyEl;
      var bookingCandidates = S.bookingCandidates;
      var wizardBooking = S.wizardBooking;
      var booking = S.booking;
      var proxyFromRoot = S.proxyFromRoot;
      var PROXY_BASE = S.PROXY_BASE;
      var PROXY_BASE_FALLBACK = S.PROXY_BASE_FALLBACK;
      var eventsPathAttr = S.eventsPathAttr;
      var EVENTS_PATH = S.EVENTS_PATH;
      var venueListSortAttr = S.venueListSortAttr;
      var VENUE_LIST_SORT_MODE = S.VENUE_LIST_SORT_MODE;
      var DEV_MODE = S.DEV_MODE;
      var __wbEvents = S.__wbEvents;
      var joinProxyPath = S.joinProxyPath;
      var fetchWorkshopEvents = S.fetchWorkshopEvents;
      var logBackendRidIfPresent = S.logBackendRidIfPresent;
      var stateInput = S.stateInput;
      var cityInput = S.cityInput;
      var variantSelect = S.variantSelect;
      var __wbLive = S.__wbLive || { variantFilterActive: false, lockedVenueRefId: '', lockedVenueGroupKey: '' };
      var variantFilterActive = __wbLive.variantFilterActive;
      var eventsRoot = S.eventsRoot;
      var eventsPlaceholder = S.eventsPlaceholder;
      var wbwDispatchVenueReset = S.wbwDispatchVenueReset;
      var showWorkshopFetchError = S.showWorkshopFetchError;
      var setLoading = S.setLoading;
      var variantWrap = S.variantWrap;
      var eventsPayloadScript = S.eventsPayloadScript;
      var productHandle = S.productHandle;
      var productGid = S.productGid;
      var useLocationFirst = S.useLocationFirst;
      var googleKeyEl = S.googleKeyEl;
      var googleKey = S.googleKey;
      var bookingBox = S.bookingBox;
      var bookingHint = S.bookingHint;
      var panelScopeRoot = S.panelScopeRoot;
      var panelTitle = S.panelTitle;
      var panelHintEl = S.panelHintEl;
      var selectedSummary = S.selectedSummary;
      var selectedEventIdInput = S.selectedEventIdInput;
      var lastPriceEl = S.lastPriceEl;
      var selectedItemsWrap = S.selectedItemsWrap;
      var selectedItemsList = S.selectedItemsList;
      var selectedItemsTotal = S.selectedItemsTotal;
      var bookNowBtn = S.bookNowBtn;
      var addToCartBtn = S.addToCartBtn;
      var wbLockedVenueRefId = S.wbLockedVenueRefId;
      var wbLockedVenueGroupKey = S.wbLockedVenueGroupKey;
      var summaryVenue = S.summaryVenue;
      var summaryVenueDetails = S.summaryVenueDetails;
      var summaryDatetime = S.summaryDatetime;
      var summaryCapacity = S.summaryCapacity;
      var summaryStatus = S.summaryStatus;
      var normalize = S.normalize;
      var normKey = S.normKey;
      var formatMoney = S.formatMoney;
      var setLastPriceElDisplay = S.setLastPriceElDisplay;
      var readJsonScriptInBooking = S.readJsonScriptInBooking;
      var WB_PRICE_DEBUG = S.WB_PRICE_DEBUG;
      var locationRules = S.locationRules;
      var venueOverrides = S.venueOverrides;
      var eventTimeOverrides = S.eventTimeOverrides;
      var getSelections = S.getSelections;
      var getSelectedVariantPriceCents = S.getSelectedVariantPriceCents;
      var getSelectedVariantId = S.getSelectedVariantId;
      var wstUpdate = S.wstUpdate;
      var wstFormatDateKey = S.wstFormatDateKey;
      var wstValues = S.wstValues;
      var wstValuesWithQty = S.wstValuesWithQty;
      var wstGetVariantNameFromButton = S.wstGetVariantNameFromButton;
      var wstGetActiveVariantName = S.wstGetActiveVariantName;
      var wstGetCurrentBookingFacts = S.wstGetCurrentBookingFacts;
      var normalizeEventIdForMatch = S.normalizeEventIdForMatch;
      var extractNumericEventIdForUrl = S.extractNumericEventIdForUrl;
      var getEventIdFromUrl = S.getEventIdFromUrl;
      var updateUrlForEventId = S.updateUrlForEventId;
      var __wbPricing = S.__wbPricing;
      var resolvePriceCents = S.resolvePriceCents;
      var diagnosticRun = S.diagnosticRun;
      var updateSelectedEventPrices = S.updateSelectedEventPrices;
      var setLastPriceFromVariant = S.setLastPriceFromVariant;
      var updateAllVariantCardPrices = S.updateAllVariantCardPrices;
      var parseVariantIdFromGid = S.parseVariantIdFromGid;
      var motionTriggerVariantById = S.motionTriggerVariantById;
      var pickCapacityFields = S.pickCapacityFields;
      var getRemainingCapacityFromCard = S.getRemainingCapacityFromCard;
      var wbRenderCapacityBadge = S.wbRenderCapacityBadge;
      var wbOpenStickyPanel = S.wbOpenStickyPanel;
      var validateSeatSelection = S.validateSeatSelection;
      var showPreviewPrice = S.showPreviewPrice;
      var buildSelectionDetailFromCard = S.buildSelectionDetailFromCard;
      var wbDispatchSelection = S.wbDispatchSelection;
      var wbApplyEventsStepHeading = S.wbApplyEventsStepHeading;
      var wbGetFirstBookableVenueCardInOpenGroup = S.wbGetFirstBookableVenueCardInOpenGroup;
      var wbLockVenueContextFromCard = S.wbLockVenueContextFromCard;
      var wbRestoreVenueContext = S.wbRestoreVenueContext;
      var wbRefreshBookingGuideUi = S.wbRefreshBookingGuideUi;
      var clearEventSelection = S.clearEventSelection;
      var getAvailableVariantIdsFromCard = S.getAvailableVariantIdsFromCard;
      var applyVariantCardVisibility = S.applyVariantCardVisibility;
      var ensureVariantUiSyncedFromSelect = S.ensureVariantUiSyncedFromSelect;
      var showSoldOutItemWarning = S.showSoldOutItemWarning;
      var setEventSelectionFromCard = S.setEventSelectionFromCard;
      var syncInCardSummaryForVenueCard = S.syncInCardSummaryForVenueCard;
      var applyFilters = S.applyFilters;
      var sortVisibleByStartsAt = S.sortVisibleByStartsAt;
      var allEventsPayload = S.allEventsPayload;
      var wbInitEventStatusLookup = S.wbInitEventStatusLookup;
      var setWbState = S.setWbState;
  document.addEventListener('workshop:event-selected', (e) => {
    const d = e && e.detail;
    if (!d || !d.eventId) return;
    window.__WORKSHOP_SELECTION__ = {
      eventId: d.eventId,
      eventHandle: d.eventHandle || '',
      city: '',
      state: '',
      venue: '',
      datetime: ''
    };
    if (selectedEventIdInput) selectedEventIdInput.value = d.eventId;
    var numericEventIdForUrl = extractNumericEventIdForUrl(d.eventId);
    window.__WB_URL_EVENT_ID_NUMERIC__ = numericEventIdForUrl || '';
    setTimeout(function () {
      updateUrlForEventId(numericEventIdForUrl);
    }, 0);
    if (useLocationFirst) {
      setWbState(2);
      if (bookNowBtn) { bookNowBtn.disabled = true; bookNowBtn.style.cursor = 'not-allowed'; }
      if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.style.cursor = 'not-allowed'; }
    }
    validateSeatSelection();
  });

  // Event selection (Date/Time selection)
  if (eventsRoot) {
    eventsRoot.addEventListener('click', (e) => {
      const card = e.target.closest('.workshop-event-card');
      if (!card) return;

      if (wbIsEventSoldOut(card)) {
        showSoldOutItemWarning();
        return;
      }
      if (!wbIsEventBookable(card)) return;

      setEventSelectionFromCard(card);
      wstUpdate(
        4,
        wstValuesWithQty(
          String(card.getAttribute('data-venue-name') || '').trim(),
          wstFormatDateKey(card.getAttribute('data-date-key') || ''),
          String(card.getAttribute('data-time-label') || '').trim(),
          '',
          String(Math.round(Number((quantityInput && quantityInput.value) || 1) || 1)),
          ''
        )
      );
      var venueCards = eventsRoot.querySelectorAll('.workshop-venue-card');
      for (var i = 0; i < venueCards.length; i++) syncInCardSummaryForVenueCard(venueCards[i]);
      if (useLocationFirst) {
        setWbState(2);
        if (bookNowBtn) { bookNowBtn.disabled = true; bookNowBtn.style.cursor = 'not-allowed'; }
        if (addToCartBtn) { addToCartBtn.disabled = true; addToCartBtn.style.cursor = 'not-allowed'; }
      }
      validateSeatSelection();

      // Force full expanded state on time-slot click. wbOpenStickyPanel can
      // no-op when bookingBox is null or no [data-ai-wb-sticky] root resolves,
      // leaving the panel neutral (no wb-panel--* class) and bypassing all
      // .wb-panel--expanded-scoped styles. Idempotent.
      var panel = booking.querySelector('[data-wb-panel]') || document.querySelector('[data-wb-panel]');
      if (panel) {
        panel.classList.remove('wb-panel--collapsed');
        panel.classList.add('wb-panel--expanded');
        panel.classList.add('wb-sticky-open');
        var expandedToggle = panel.querySelector('[data-ai-wb-sticky-toggle]');
        if (expandedToggle) expandedToggle.setAttribute('aria-expanded', 'true');
        var expandedBody = panel.querySelector('[data-ai-wb-sticky-body]');
        if (expandedBody) {
          expandedBody.style.maxHeight = '';
          expandedBody.style.overflow = '';
          expandedBody.classList.remove('pdp-wb-hidden');
        }
      }
      requestAnimationFrame(function () {
        var kitAnchor = document.querySelector('[data-wst-anchor="kit"]');
        if (kitAnchor) {
          var header = document.querySelector('header, .site-header, #shopify-section-header');
          var headerH = header ? Math.ceil(header.getBoundingClientRect().height) + 8 : 80;
          var rect = kitAnchor.getBoundingClientRect();
          var viewH = window.innerHeight - headerH;
          var targetH = rect.height;
          var offset = window.scrollY + rect.top - headerH - Math.max(0, (viewH - targetH) / 2);
          window.scrollTo({ top: Math.round(Math.max(0, offset)), behavior: 'smooth' });
        }
      });
    });
  }

  // Quantity change handler for capacity validation (metaobject-based)
  const quantityInput = bookingBox ? bookingBox.querySelector('[data-workshop-quantity]') : null;
  var qtyMinusBtn = bookingBox ? bookingBox.querySelector('[data-wb-qty-minus]') : null;
  var qtyPlusBtn = bookingBox ? bookingBox.querySelector('[data-wb-qty-plus]') : null;
  function wbClampAndValidateQty(nextValue) {
    if (!quantityInput) return;
    var min = Math.max(1, Number(quantityInput.getAttribute('min') || 1));
    var maxRaw = Number(quantityInput.getAttribute('max'));
    var hasMax = Number.isFinite(maxRaw) && maxRaw > 0;
    var n = Number(nextValue);
    if (!Number.isFinite(n)) n = min;
    n = Math.round(n);
    if (n < min) n = min;
    if (hasMax && n > maxRaw) n = maxRaw;
    quantityInput.value = String(n);
    validateSeatSelection();
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (quantityInput) {
    quantityInput.addEventListener('input', (e) => {
      validateSeatSelection();
      if (typeof wbUpdateSelectedItemsSummary === 'function') wbUpdateSelectedItemsSummary();
      var factsOnQtyInput = wstGetCurrentBookingFacts();
      if (factsOnQtyInput && factsOnQtyInput.venueName && factsOnQtyInput.dateLabel && factsOnQtyInput.timeLabel && factsOnQtyInput.variantName) {
        var addonForStep = typeof addonSelection === 'function' ? addonSelection() : null;
        var wstStepForQty = addonForStep && addonForStep.selected ? 6 : 5;
        wstUpdate(
          wstStepForQty,
          wstValuesWithQty(
            factsOnQtyInput.venueName,
            factsOnQtyInput.dateLabel,
            factsOnQtyInput.timeLabel,
            factsOnQtyInput.variantName,
            factsOnQtyInput.qtyLabel || '',
            factsOnQtyInput.extrasName || 'None'
          )
        );
      }
    });
    
    quantityInput.addEventListener('change', (e) => {
      validateSeatSelection();
      if (typeof wbUpdateSelectedItemsSummary === 'function') wbUpdateSelectedItemsSummary();
      var factsOnQtyChange = wstGetCurrentBookingFacts();
      if (factsOnQtyChange && factsOnQtyChange.venueName && factsOnQtyChange.dateLabel && factsOnQtyChange.timeLabel && factsOnQtyChange.variantName) {
        var addonForStepCh = typeof addonSelection === 'function' ? addonSelection() : null;
        var wstStepForQtyCh = addonForStepCh && addonForStepCh.selected ? 6 : 5;
        wstUpdate(
          wstStepForQtyCh,
          wstValuesWithQty(
            factsOnQtyChange.venueName,
            factsOnQtyChange.dateLabel,
            factsOnQtyChange.timeLabel,
            factsOnQtyChange.variantName,
            factsOnQtyChange.qtyLabel || '',
            factsOnQtyChange.extrasName || 'None'
          )
        );
      }
    });
  }
  if (qtyMinusBtn && !qtyMinusBtn.dataset.wbBound) {
    qtyMinusBtn.dataset.wbBound = '1';
    qtyMinusBtn.addEventListener('click', function () {
      var current = Number((quantityInput && quantityInput.value) || 1);
      wbClampAndValidateQty(current - 1);
    });
  }
  if (qtyPlusBtn && !qtyPlusBtn.dataset.wbBound) {
    qtyPlusBtn.dataset.wbBound = '1';
    qtyPlusBtn.addEventListener('click', function () {
      var current = Number((quantityInput && quantityInput.value) || 1);
      wbClampAndValidateQty(current + 1);
    });
  }

  // Bind validation to event selection
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.workshop-event-card');
    if (card) {
      // Existing selection logic is handled by setEventSelectionFromCard
      // Just validate capacity after selection
      setTimeout(() => {
        validateSeatSelection();
      }, 0);
    }
  });

  // Listen to selector changes
  window.addEventListener('workshop:filter-changed', applyFilters);
  if (!useLocationFirst) {
    if (stateInput) stateInput.addEventListener('input', applyFilters);
    if (cityInput) cityInput.addEventListener('input', applyFilters);
  }
  function handleVariantChange() {
    __wbLive.variantFilterActive = true;
    if (useLocationFirst && S.getWbState() === 2) setWbState(3);
    applyFilters();
    var selectedCard = eventsRoot ? eventsRoot.querySelector('.workshop-event-card.is-selected') : null;
    if (!selectedCard) {
      var sheetRoot1 = document.getElementById('wb-sheet-body');
      var hasSheetBookingUi1 = sheetRoot1 && sheetRoot1.querySelector('.pdp-workshop-booking');
      var inSheetContext1 = !!(booking && booking.closest && booking.closest('#wb-sheet-body'));
      if (hasSheetBookingUi1 && inSheetContext1) {
        selectedCard =
          document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
          document.querySelector('.wb-all__event-card.is-selected');
      }
    }
    if (selectedCard) {
      showPreviewPrice(selectedCard);
      var detail = buildSelectionDetailFromCard(selectedCard);
      if (detail) wbDispatchSelection(detail);
    } else {
      setLastPriceFromVariant();
    }
    updateAllVariantCardPrices();
  }

  booking.querySelectorAll('.wb-variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      booking.querySelectorAll('.wb-variant-btn').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var vid = btn.dataset.variantId || '';
      if (variantSelect) variantSelect.value = vid;
      motionTriggerVariantById(vid);
      handleVariantChange();
      var selectedCard = eventsRoot ? eventsRoot.querySelector('.workshop-event-card.is-selected') : null;
      if (selectedCard) {
        var variantNameClick = String(btn.getAttribute('data-variant-title') || btn.dataset.variantTitle || '').trim();
        if (!variantNameClick) {
          var variantTitleElClick = btn.querySelector('.wb-variant-title');
          variantNameClick = variantTitleElClick ? String(variantTitleElClick.textContent || '').trim() : '';
        }
        wstUpdate(
          5,
          wstValuesWithQty(
            String(selectedCard.getAttribute('data-venue-name') || '').trim(),
            wstFormatDateKey(selectedCard.getAttribute('data-date-key') || ''),
            String(selectedCard.getAttribute('data-time-label') || '').trim(),
            variantNameClick,
            String(Math.round(Number((quantityInput && quantityInput.value) || 1) || 1)),
            ''
          )
        );
      }
      wbKeepStandaloneSheetExpanded();
    });
  });

  if (variantSelect) variantSelect.addEventListener('change', function () {
    motionTriggerVariantById(variantSelect.value);
    handleVariantChange();
    var selectedCard = eventsRoot ? eventsRoot.querySelector('.workshop-event-card.is-selected') : null;
    if (selectedCard) {
      var activeBtnFromChange = booking ? booking.querySelector('.wb-variant-btn.is-active') : null;
      var variantNameChange = activeBtnFromChange ? String(activeBtnFromChange.getAttribute('data-variant-title') || activeBtnFromChange.dataset.variantTitle || '').trim() : '';
      if (!variantNameChange && activeBtnFromChange) {
        var variantTitleElChange = activeBtnFromChange.querySelector('.wb-variant-title');
        variantNameChange = variantTitleElChange ? String(variantTitleElChange.textContent || '').trim() : '';
      }
      wstUpdate(
        5,
        wstValuesWithQty(
          String(selectedCard.getAttribute('data-venue-name') || '').trim(),
          wstFormatDateKey(selectedCard.getAttribute('data-date-key') || ''),
          String(selectedCard.getAttribute('data-time-label') || '').trim(),
          variantNameChange,
          String(Math.round(Number((quantityInput && quantityInput.value) || 1) || 1)),
          ''
        )
      );
    }
  });

  // Initial price on load: show selected variant base price before any event selection
  setLastPriceFromVariant();
  updateAllVariantCardPrices();
  wstUpdate(1, {});

  function wbIsStandaloneMobileSheetContext() {
    return !!(
      booking &&
      booking.classList &&
      booking.classList.contains('wb-standalone') &&
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(max-width: 1024px)').matches
    );
  }

  function wbKeepStandaloneSheetExpanded() {
    if (!wbIsStandaloneMobileSheetContext()) return;
    var panel = (booking && booking.closest && booking.closest('[data-wb-panel]')) ||
      (booking && booking.querySelector && booking.querySelector('[data-wb-panel]')) ||
      document.querySelector('[data-wb-panel]');
    if (!panel) return;
    var toggle = panel.querySelector('[data-ai-wb-sticky-toggle]');
    var body = panel.querySelector('[data-ai-wb-sticky-body]');
    var alreadyExpanded =
      panel.classList.contains('wb-panel--expanded') &&
      !panel.classList.contains('wb-panel--collapsed') &&
      panel.classList.contains('wb-sticky-open') &&
      (!toggle || toggle.getAttribute('aria-expanded') === 'true') &&
      (!body || !body.classList.contains('pdp-wb-hidden'));
    if (alreadyExpanded) return;

    panel.classList.remove('wb-panel--collapsed');
    panel.classList.add('wb-panel--expanded');
    panel.classList.add('wb-sticky-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (body) {
      body.style.maxHeight = '';
      body.style.overflow = '';
      body.classList.remove('pdp-wb-hidden');
    }
  }

  function wbCloseStandaloneMobilePanel() {
    if (!wbIsStandaloneMobileSheetContext()) return;
    var panel = (booking && booking.closest && booking.closest('[data-ai-wb-sticky]')) ||
      (booking && booking.closest && booking.closest('[data-wb-panel]')) ||
      (booking && booking.querySelector && booking.querySelector('[data-ai-wb-sticky]')) ||
      (booking && booking.querySelector && booking.querySelector('[data-wb-panel]')) ||
      document.querySelector('[data-ai-wb-sticky]') ||
      document.querySelector('[data-wb-panel]');
    if (!panel) return;
    panel.classList.remove('wb-panel--expanded');
    panel.classList.remove('wb-sticky-open');
    panel.classList.add('wb-panel--collapsed');
    var toggle = panel.querySelector('[data-ai-wb-sticky-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    var body = panel.querySelector('[data-ai-wb-sticky-body]');
    if (body) {
      body.style.maxHeight = '0px';
      body.style.overflow = 'hidden';
      body.classList.add('pdp-wb-hidden');
    }
    wbCloseMobilePreview();
  }

  // Optional add-on card (mobile sheet): selectable state for Turkish Coffee.
  var addonCard = null;
  var addonCards = [];
  var addonQtyInputs = [];
  var addonQtyMinusBtns = [];
  var addonQtyPlusBtns = [];
  if (bookingBox) {
    var addonCandidates = bookingBox.querySelectorAll('[data-wb-addon-card]');
    addonCards = Array.prototype.slice.call(addonCandidates || []);
    addonQtyInputs = Array.prototype.slice.call(bookingBox.querySelectorAll('[data-wb-addon-qty-input]') || []);
    addonQtyMinusBtns = Array.prototype.slice.call(bookingBox.querySelectorAll('[data-wb-addon-qty-minus]') || []);
    addonQtyPlusBtns = Array.prototype.slice.call(bookingBox.querySelectorAll('[data-wb-addon-qty-plus]') || []);
    for (var ai = 0; ai < addonCandidates.length; ai++) {
      var cand = addonCandidates[ai];
      if (!cand) continue;
      var candStyle = window.getComputedStyle ? window.getComputedStyle(cand) : null;
      var hiddenByCss = candStyle && (candStyle.display === 'none' || candStyle.visibility === 'hidden');
      if (hiddenByCss) continue;
      addonCard = cand;
      break;
    }
    if (!addonCard) addonCard = addonCandidates[0] || null;
    addonCards.forEach(function (card) {
      card.removeAttribute('data-wst-anchor');
    });
    if (addonCard) addonCard.setAttribute('data-wst-anchor', 'extras');
  }
  function getWorkshopQtyValue() {
    var n = Number((quantityInput && quantityInput.value) || 1);
    if (!Number.isFinite(n) || n < 1) n = 1;
    return Math.round(n);
  }
  function clampAddonQty(nextValue) {
    var n = Number(nextValue);
    if (!Number.isFinite(n)) n = 0;
    n = Math.round(n);
    if (n < 0) n = 0;
    return n;
  }
  function setAddonQty(nextValue) {
    var n = clampAddonQty(nextValue);
    addonCards.forEach(function (card) {
      if (!card) return;
      card.setAttribute('data-addon-quantity', String(n));
    });
    addonQtyInputs.forEach(function (input) {
      if (!input) return;
      input.value = String(n);
    });
    if (typeof wbUpdateSelectedItemsSummary === 'function') wbUpdateSelectedItemsSummary();
  }
  function getAddonQty() {
    var primaryCard = addonCard || (addonCards.length ? addonCards[0] : null);
    var raw = primaryCard ? primaryCard.getAttribute('data-addon-quantity') : '';
    if ((!raw || !raw.trim()) && addonQtyInputs.length) raw = addonQtyInputs[0].value;
    return clampAddonQty(raw);
  }
  var mobilePreviewEnabled = ((booking && booking.dataset && booking.dataset.wbMobilePreviewEnabled) || 'true') !== 'false';
  var mobilePreviewSubtitle = ((booking && booking.dataset && booking.dataset.wbMobilePreviewSubtitle) || 'Variant details').trim() || 'Variant details';
  var mobilePreviewOffset = Number((booking && booking.dataset && booking.dataset.wbMobilePreviewOffset) || 14);
  if (!Number.isFinite(mobilePreviewOffset)) mobilePreviewOffset = 14;
  function addonSelection() {
    var primaryCard = addonCard || (addonCards.length ? addonCards[0] : null);
    if (!primaryCard) return { selected: false, variantId: '', title: '', quantity: 0 };
    var selected = addonCards.some(function (card) { return card.classList.contains('is-active'); });
    var vid = (primaryCard.getAttribute('data-addon-variant-id') || '').trim();
    var title = (primaryCard.getAttribute('data-addon-title') || 'Addon').trim();
    var qty = getAddonQty();
    return { selected: selected, variantId: vid, title: title, quantity: qty };
  }
  function wbGetSelectedVariantTitleForSummary() {
    var activeBtn = booking ? booking.querySelector('.wb-variant-btn.is-active') : null;
    if (activeBtn) {
      var t = (activeBtn.getAttribute('data-variant-title') || '').trim();
      if (t) return t;
    }
    var selectedId = String((variantSelect && variantSelect.value) || '').trim();
    if (selectedId && booking && booking.querySelector) {
      var fallbackBtn = booking.querySelector('.wb-variant-btn[data-variant-id="' + CSS.escape(selectedId) + '"]');
      if (fallbackBtn) {
        var ft = (fallbackBtn.getAttribute('data-variant-title') || '').trim();
        if (ft) return ft;
      }
    }
    return 'Workshop';
  }
  function wbUpdateSelectedItemsSummary() {
    if (!selectedItemsWrap || !selectedItemsList) return;
    var workshopQty = getWorkshopQtyValue();
    var variantTitle = wbGetSelectedVariantTitleForSummary();
    var addon = addonSelection();
    var chips = [];
    if (workshopQty > 0) {
      chips.push('<span class="wb-selected-items__chip"><span class="wb-selected-items__chip-qty">' + workshopQty + '</span> ' + variantTitle + '</span>');
    }
    if (addon && addon.selected && addon.quantity > 0) {
      chips.push('<span class="wb-selected-items__chip"><span class="wb-selected-items__chip-qty">' + addon.quantity + '</span> ' + (addon.title || 'Turkish Coffee') + '</span>');
    }
    if (!chips.length) {
      selectedItemsList.innerHTML = '';
      if (selectedItemsTotal) selectedItemsTotal.textContent = 'Total: —';
      selectedItemsWrap.classList.add('pdp-wb-hidden');
      return;
    }
    selectedItemsList.innerHTML = chips.join('');
    var activeVariantBtn = booking ? booking.querySelector('.wb-variant-btn.is-active') : null;
    var baseCents = activeVariantBtn && activeVariantBtn.dataset && activeVariantBtn.dataset.basePrice
      ? parseInt(activeVariantBtn.dataset.basePrice, 10)
      : null;
    if (!Number.isFinite(baseCents) || baseCents <= 0) {
      var fallbackBase = getSelectedVariantPriceCents();
      baseCents = (Number.isFinite(fallbackBase) && fallbackBase > 0) ? fallbackBase : 0;
    }
    var addonPriceRaw = addonCard ? (addonCard.getAttribute('data-addon-price') || '') : '';
    var addonPriceCents = 0;
    if (addonPriceRaw) {
      try {
        var cleaned = String(addonPriceRaw).replace(/[^0-9.,]/g, '').replace(/,/g, '');
        var parsed = Number(cleaned);
        if (Number.isFinite(parsed) && parsed >= 0) addonPriceCents = Math.round(parsed * 100);
      } catch (_) {}
    }
    var totalCents = Math.max(0, workshopQty) * Math.max(0, baseCents || 0);
    if (addon && addon.selected && addon.quantity > 0) {
      totalCents += Math.max(0, addon.quantity) * Math.max(0, addonPriceCents || 0);
    }
    if (selectedItemsTotal) {
      selectedItemsTotal.textContent = totalCents > 0 ? ('Total: ' + formatMoney(totalCents)) : 'Total: —';
    }
    selectedItemsWrap.classList.remove('pdp-wb-hidden');
  }
  function setAddonActive(next) {
    if (!addonCards || !addonCards.length) return;
    addonCards.forEach(function (card) {
      card.classList.toggle('is-active', !!next);
      card.setAttribute('aria-pressed', next ? 'true' : 'false');
    });
    if (typeof wbUpdateSelectedItemsSummary === 'function') wbUpdateSelectedItemsSummary();
  }
  setAddonQty(0);
  addonCards.forEach(function (card) {
    if (!card || card.dataset.wbBound) return;
    card.dataset.wbBound = '1';
    if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
    if (!card.hasAttribute('role')) card.setAttribute('role', 'button');
    card.addEventListener('click', function (e) {
      if (e && e.target && e.target.closest && e.target.closest('[data-wb-addon-qty-control]')) return;
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var next = !card.classList.contains('is-active');
      if (next) setAddonQty(getAddonQty());
      setAddonActive(next);
      var factsOnAddon = wstGetCurrentBookingFacts();
      if (factsOnAddon && factsOnAddon.venueName && factsOnAddon.dateLabel && factsOnAddon.timeLabel && factsOnAddon.variantName) {
        wstUpdate(
          6,
          wstValuesWithQty(
            factsOnAddon.venueName,
            factsOnAddon.dateLabel,
            factsOnAddon.timeLabel,
            factsOnAddon.variantName,
            factsOnAddon.qtyLabel || '',
            next ? (String(card.getAttribute('data-addon-title') || 'Extras').trim() || 'Extras') : 'None'
          )
        );
      }
      wbKeepStandaloneSheetExpanded();
    });
    card.addEventListener('keydown', function (e) {
      if (!e) return;
      var key = e.key || '';
      if (key !== 'Enter' && key !== ' ') return;
      e.preventDefault();
      card.click();
    });
  });
  addonQtyMinusBtns.forEach(function (btn) {
    if (!btn || btn.dataset.wbBound) return;
    btn.dataset.wbBound = '1';
    btn.addEventListener('click', function (e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      setAddonQty(getAddonQty() - 1);
      setAddonActive(true);
      wbKeepStandaloneSheetExpanded();
    });
  });
  addonQtyPlusBtns.forEach(function (btn) {
    if (!btn || btn.dataset.wbBound) return;
    btn.dataset.wbBound = '1';
    btn.addEventListener('click', function (e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      setAddonQty(getAddonQty() + 1);
      setAddonActive(true);
      wbKeepStandaloneSheetExpanded();
    });
  });
  addonQtyInputs.forEach(function (input) {
    if (!input || input.dataset.wbBound) return;
    input.dataset.wbBound = '1';
    input.addEventListener('click', function (e) {
      if (e) e.stopPropagation();
    });
    input.addEventListener('input', function (e) {
      if (e) e.stopPropagation();
      setAddonQty(input.value);
      setAddonActive(true);
    });
    input.addEventListener('change', function (e) {
      if (e) e.stopPropagation();
      setAddonQty(input.value);
      setAddonActive(true);
    });
  });
  if (booking && !booking.dataset.wbSelectedItemsBound) {
    booking.dataset.wbSelectedItemsBound = '1';
    booking.addEventListener('click', function (e) {
      if (!e || !e.target || !e.target.closest) return;
      if (e.target.closest('.wb-variant-btn')) {
        setTimeout(function () { wbUpdateSelectedItemsSummary(); }, 0);
      }
    });
  }
  if (variantSelect && !variantSelect.dataset.wbSelectedItemsBound) {
    variantSelect.dataset.wbSelectedItemsBound = '1';
    variantSelect.addEventListener('change', wbUpdateSelectedItemsSummary);
  }
  wbUpdateSelectedItemsSummary();

  function wbIsMobilePreviewMode() {
    if (!mobilePreviewEnabled) return false;
    return typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(max-width: 1024px)').matches;
  }
  function wbIsDesktopPreviewMode() {
    if (!mobilePreviewEnabled) return false;
    return typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(min-width: 1025px)').matches;
  }

  function wbEnsureMobilePreviewEl() {
    var pop = document.getElementById('wb-mobile-preview');
    if (pop) return pop;
    pop = document.createElement('div');
    pop.id = 'wb-mobile-preview';
    pop.className = 'wb-mobile-preview';
    pop.innerHTML =
      '<div class="wb-mobile-preview__inner">' +
        '<div class="wb-mobile-preview__thumb"><img alt=""></div>' +
        '<div class="wb-mobile-preview__body">' +
          '<p class="wb-mobile-preview__title"></p>' +
          '<p class="wb-mobile-preview__subtitle"></p>' +
          '<p class="wb-mobile-preview__price"></p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);
    return pop;
  }

  function wbCloseMobilePreview() {
    var pop = document.getElementById('wb-mobile-preview');
    if (!pop) return;
    pop.classList.remove('is-open');
  }

  var wbPreviewImageCache = {};
  function wbPreloadPreviewImage(url) {
    var u = (url || '').trim();
    if (!u) return;
    if (wbPreviewImageCache[u] === 'loaded' || wbPreviewImageCache[u] === 'loading') return;
    wbPreviewImageCache[u] = 'loading';
    try {
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { wbPreviewImageCache[u] = 'loaded'; };
      im.onerror = function () { wbPreviewImageCache[u] = 'error'; };
      im.src = u;
    } catch (e) {
      wbPreviewImageCache[u] = 'error';
    }
  }

  function wbOpenMobilePreview(payload, anchorEl) {
    if (!mobilePreviewEnabled) return;
    var pop = wbEnsureMobilePreviewEl();
    if (!pop) return;
    var imgEl = pop.querySelector('.wb-mobile-preview__thumb img');
    var titleEl = pop.querySelector('.wb-mobile-preview__title');
    var subtitleEl = pop.querySelector('.wb-mobile-preview__subtitle');
    var priceEl = pop.querySelector('.wb-mobile-preview__price');
    if (titleEl) titleEl.textContent = payload.title || '';
    if (subtitleEl) {
      var sub = (payload.subtitle || '').trim();
      subtitleEl.textContent = sub;
      subtitleEl.style.display = sub ? '' : 'none';
    }
    if (priceEl) {
      if (payload.price) {
        priceEl.textContent = payload.price;
        priceEl.style.display = '';
      } else {
        priceEl.textContent = '';
        priceEl.style.display = 'none';
      }
    }
    if (imgEl) {
      if (payload.imageFast) {
        imgEl.src = payload.imageFast;
        imgEl.style.display = '';
      } else if (payload.image) {
        imgEl.src = payload.image;
        imgEl.style.display = '';
      } else {
        imgEl.src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2296%22 height=%2296%22 viewBox=%220 0 96 96%22%3E%3Crect width=%2296%22 height=%2296%22 rx=%2212%22 fill=%22%23f1f3f5%22/%3E%3Cpath d=%22M30 60l12-14 8 10 10-12 16 16H20l10-12z%22 fill=%22%23d0d4d9%22/%3E%3Ccircle cx=%2240%22 cy=%2238%22 r=%226%22 fill=%22%23d0d4d9%22/%3E%3C/svg%3E';
        imgEl.style.display = '';
      }
      // Upgrade to high-res once ready (avoids 1-2s blank delay on first open).
      var hi = (payload.image || '').trim();
      var fast = (payload.imageFast || '').trim();
      if (hi && hi !== fast) {
        wbPreloadPreviewImage(hi);
        if (wbPreviewImageCache[hi] === 'loaded') {
          imgEl.src = hi;
        } else {
          var upgrade = new Image();
          upgrade.onload = function () {
            wbPreviewImageCache[hi] = 'loaded';
            var popNow = document.getElementById('wb-mobile-preview');
            if (!popNow || !popNow.classList.contains('is-open')) return;
            var live = popNow.querySelector('.wb-mobile-preview__thumb img');
            if (live) live.src = hi;
          };
          upgrade.onerror = function () { wbPreviewImageCache[hi] = 'error'; };
          upgrade.src = hi;
        }
      }
    }
    // Position preview in upper free area (not over Add to Cart / Book Now).
    try {
      var vw = window.innerWidth || document.documentElement.clientWidth || 0;
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      var pad = 16;
      // Phone-only: smaller card (tablet 751px+ keeps 360 cap — matches theme workshop mobile breakpoint).
      var maxWCap = vw <= 750 ? 284 : 360;
      var maxW = Math.min(vw - pad * 2, maxWCap);
      pop.style.width = maxW + 'px';
      var left = pad;
      if (anchorEl && anchorEl.getBoundingClientRect) {
        var ar = anchorEl.getBoundingClientRect();
        left = Math.round(ar.left + (ar.width / 2) - (maxW / 2));
      }
      var minLeft = pad;
      var maxLeft = Math.max(pad, vw - maxW - pad);
      if (left < minLeft) left = minLeft;
      if (left > maxLeft) left = maxLeft;
      pop.style.left = left + 'px';

      // Pin preview in free space above the workshop sheet.
      // Use the real rendered popup height (not a fixed guess), otherwise
      // large preview cards open too low and cover variant tiles.
      var previewRect = pop.getBoundingClientRect ? pop.getBoundingClientRect() : null;
      var previewH = Math.round((previewRect && previewRect.height) || pop.offsetHeight || 0);
      if (!previewH || previewH < 120) previewH = 132;
      var targetTop = 84;
      try {
        var sheetEl = document.getElementById('wb-sheet');
        if (sheetEl && sheetEl.getBoundingClientRect) {
          var sh = sheetEl.getBoundingClientRect();
          if (sh && Number.isFinite(sh.top)) targetTop = Math.round(sh.top - previewH - mobilePreviewOffset - 12);
        }
      } catch (e2) {}
      var minTop = 40;
      var maxTop = Math.max(minTop, Math.round(vh * 0.42) - previewH);
      if (targetTop < minTop) targetTop = minTop;
      if (targetTop > maxTop) targetTop = maxTop;

      // Phone-only: pin magnify popup above variant tiles (tablet 751px+ keeps prior vertical rules).
      if (vw <= 750) {
        var phoneMinTop = 48;
        var tuckGap = 12;
        var tightTop = Math.max(phoneMinTop, Math.round(vh * 0.3) - previewH);
        targetTop = Math.min(targetTop, tightTop);
        var variantSlot =
          (booking && booking.querySelector && (
            booking.querySelector('[data-workshop-variant-wrap]') ||
            booking.querySelector('.wb-variant-cards')
          )) ||
          document.querySelector('.pdp-workshop-booking [data-workshop-variant-wrap]') ||
          document.querySelector('.pdp-workshop-booking .wb-variant-cards');
        try {
          if (variantSlot && variantSlot.getBoundingClientRect) {
            var vrr = variantSlot.getBoundingClientRect();
            var vTopRaw = Number(vrr.top);
            if (Number.isFinite(vTopRaw) && vrr.height > 2 && vTopRaw > phoneMinTop) {
              var aboveVariants = Math.round(vTopRaw - previewH - tuckGap);
              targetTop = Math.min(targetTop, aboveVariants);
            }
          }
        } catch (eVp) {}
        if (targetTop < phoneMinTop) targetTop = phoneMinTop;
      }

      pop.style.top = targetTop + 'px';
    } catch (e) {}
    pop.classList.add('is-open');
    window.__WB_LAST_PREVIEW_ANCHOR__ = anchorEl || null;
  }

  if (!window.__WB_MOBILE_PREVIEW_CLOSE_BOUND__) {
    window.__WB_MOBILE_PREVIEW_CLOSE_BOUND__ = true;
    document.addEventListener('pointerdown', function (e) {
      var pop = document.getElementById('wb-mobile-preview');
      if (!pop || !pop.classList.contains('is-open')) return;
      var anchor = window.__WB_LAST_PREVIEW_ANCHOR__;
      if (pop.contains(e.target)) return;
      if (anchor && anchor.contains && anchor.contains(e.target)) return;
      wbCloseMobilePreview();
    });
  }

  function wbBindMobilePreviewTarget(el, payloadBuilder) {
    if (!el || !payloadBuilder || el.dataset.wbPreviewBound === '1') return;
    el.dataset.wbPreviewBound = '1';
    var longPressTimer = null;
    var longPressOpened = false;
    var LONG_PRESS_MS = 420;
    function isStandaloneMobilePreviewContext() {
      return !!(
        booking &&
        booking.classList &&
        booking.classList.contains('wb-standalone') &&
        typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(max-width: 750px)').matches
      );
    }
    function clearLongPress() {
      if (longPressTimer) {
        clearTimeout(longPressTimer);
        longPressTimer = null;
      }
    }
    el.addEventListener('pointerdown', function (e) {
      if (isStandaloneMobilePreviewContext() && e) e.stopPropagation();
      if (!wbIsMobilePreviewMode()) return;
      longPressOpened = false;
      clearLongPress();
      longPressTimer = setTimeout(function () {
        longPressTimer = null;
        longPressOpened = true;
        wbOpenMobilePreview(payloadBuilder(el), el);
      }, LONG_PRESS_MS);
    });
    el.addEventListener('pointerup', clearLongPress);
    el.addEventListener('pointerleave', clearLongPress);
    el.addEventListener('pointercancel', clearLongPress);
    el.addEventListener('click', function (e) {
      if (isStandaloneMobilePreviewContext() && e) e.stopPropagation();
      if (!wbIsMobilePreviewMode()) return;
      if (longPressOpened) {
        longPressOpened = false;
        return;
      }
      wbOpenMobilePreview(payloadBuilder(el), el);
    });
    el.addEventListener('mouseenter', function () {
      if (!wbIsDesktopPreviewMode()) return;
      wbOpenMobilePreview(payloadBuilder(el), el);
    });
    el.addEventListener('mouseleave', function () {
      if (!wbIsDesktopPreviewMode()) return;
      wbCloseMobilePreview();
    });
  }

  booking.querySelectorAll('.wb-variant-btn').forEach(function (btn) {
    wbPreloadPreviewImage((btn.getAttribute('data-variant-preview-image') || '').trim());
    wbBindMobilePreviewTarget(btn, function (target) {
      var largePreview = (target.getAttribute('data-variant-preview-image') || '').trim();
      var img = target.querySelector('.wb-variant-img');
      var title = target.querySelector('.wb-variant-title');
      var price = target.querySelector('[data-variant-price]') || target.querySelector('.wb-variant-price');
      return {
        imageFast: img ? (img.currentSrc || img.src || img.getAttribute('src') || img.getAttribute('data-src') || '') : '',
        image: largePreview || (img ? (img.currentSrc || img.src || img.getAttribute('src') || img.getAttribute('data-src') || '') : ''),
        title: title ? title.textContent.trim() : 'Workshop variant',
        subtitle: '',
        price: price ? price.textContent.trim() : ''
      };
    });
  });
  addonCards.forEach(function (card) {
    if (!card) return;
    wbPreloadPreviewImage((card.getAttribute('data-addon-preview-image') || '').trim());
    wbBindMobilePreviewTarget(card, function (target) {
      var largePreview = (target.getAttribute('data-addon-preview-image') || '').trim();
      var img = target.querySelector('.wb-addon-turkish__thumb img');
      var title = target.querySelector('.wb-addon-turkish__title');
      var subtitle = target.querySelector('.wb-addon-turkish__sub');
      var addonPrice = (target.getAttribute('data-addon-price') || '').trim();
      return {
        imageFast: img ? (img.currentSrc || img.src || '') : '',
        image: largePreview || (img ? (img.currentSrc || img.src || '') : ''),
        title: title ? title.textContent.trim() : 'Turkish Coffee',
        subtitle: subtitle ? subtitle.textContent.trim() : 'Add-on',
        price: addonPrice
      };
    });
  });

  /**
   * JSON items format for cart/add.js (Shopify documented format).
   * Workshop discount shape (UK BXGY-style drawer, Liquid-visible):
   * - qty 1 → one mergeable line (`_unique` = variant:event)
   * - qty N≥2 AND cheapest → paid qty N-1 @ `…:seat:stack` then free qty1 @ base
   *   (Function discounts the newest line → base must be added last for $0 row)
   * - qty N≥2 non-cheapest → one merged line (Short Table style)
   * Drawer normalize also enforces cheapest-only split.
   */
  function copyProps(src) {
    var out = {};
    for (var k in (src || {})) {
      if (src[k] != null && src[k] !== '') out[k] = String(src[k]);
    }
    return out;
  }

  function workshopSeatBase(variantId, properties) {
    return (
      String(variantId) +
      ':' +
      String((properties && (properties._event_metaobject_gid || properties._event_id)) || 'seat')
    );
  }

  function workshopUnitSellCentsFromProps(properties) {
    var resolved = parseInt(
      String((properties && (properties._resolved_price_cents || properties._resolved_price)) || ''),
      10
    );
    if (Number.isFinite(resolved) && resolved > 0) return resolved;
    return Number.POSITIVE_INFINITY;
  }

  function isWorkshopCartItemProps(item) {
    if (!item || !item.properties) return false;
    var p = item.properties;
    return p._workshop === 'true' || p._is_workshop === '1' || !!(p._event_metaobject_gid || p._event_id);
  }

  function cartItemUnitSellCents(item) {
    if (!item) return Number.POSITIVE_INFINITY;
    var p = item.properties || {};
    var resolved = parseInt(String(p._resolved_price_cents || p._resolved_price || ''), 10);
    if (Number.isFinite(resolved) && resolved > 0) return resolved;
    if (item.original_price != null && Number(item.original_price) > 0) return Number(item.original_price);
    if (item.price != null && Number(item.price) > 0) return Number(item.price);
    return Number.POSITIVE_INFINITY;
  }

  async function shouldSplitCheapestSku(variantId, properties) {
    var thisCents = workshopUnitSellCentsFromProps(properties);
    var thisVid = String(variantId);
    var thisEvent = String(
      (properties && (properties._event_metaobject_gid || properties._event_id)) || ''
    );
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var res = await fetch(root + 'cart.js', { credentials: 'same-origin' });
      if (!res.ok) return true;
      var cart = await res.json();
      var otherMin = Number.POSITIVE_INFINITY;
      (cart.items || []).forEach(function (it) {
        if (!isWorkshopCartItemProps(it)) return;
        var p = it.properties || {};
        var vid = String(it.variant_id || it.id || '');
        var eid = String(p._event_metaobject_gid || p._event_id || '');
        if (vid === thisVid && eid === thisEvent) return;
        var c = cartItemUnitSellCents(it);
        if (c < otherMin) otherMin = c;
      });
      if (!Number.isFinite(thisCents)) return otherMin === Number.POSITIVE_INFINITY;
      return !(otherMin < thisCents);
    } catch (_) {
      return true;
    }
  }

  async function buildCartAddPayload(variantId, quantity, properties, sections = [], extraItems = []) {
    var qty = Math.max(1, parseInt(String(quantity), 10) || 1);
    var variantNum = parseInt(String(variantId), 10);
    var baseProps = copyProps(properties);
    var seatBase = workshopSeatBase(variantNum, baseProps);
    var items = [];
    var split = qty >= 2 && (await shouldSplitCheapestSku(variantNum, baseProps));
    if (!split) {
      var merged = copyProps(baseProps);
      merged._unique = seatBase;
      items.push({ id: variantNum, quantity: qty, properties: merged });
    } else {
      // Paid stack first, free base last — Function allocates to newest line.
      var paidLine = copyProps(baseProps);
      paidLine._unique = seatBase + ':seat:stack';
      items.push({ id: variantNum, quantity: qty - 1, properties: paidLine });
      var freeLine = copyProps(baseProps);
      freeLine._unique = seatBase;
      items.push({ id: variantNum, quantity: 1, properties: freeLine });
    }
    if (Array.isArray(extraItems) && extraItems.length > 0) {
      extraItems.forEach(function (it) {
        if (!it || it.id == null) return;
        var addonId = parseInt(String(it.id), 10);
        if (!Number.isFinite(addonId) || addonId <= 0) return;
        items.push({
          id: addonId,
          quantity: Math.max(1, parseInt(String(it.quantity), 10) || 1),
          properties: it.properties && typeof it.properties === 'object' ? it.properties : {}
        });
      });
    }
    var payload = { items: items };
    if (Array.isArray(sections) && sections.length > 0) {
      payload.sections = sections.join(',');
      payload.sections_url = (typeof window !== 'undefined' && window.location && window.location.pathname) || '/';
    }
    return payload;
  }

  // Helper: Get total seats already in cart for a specific event from cart data.
  // Cart.js returns item.properties as object { key: value }; support that and array-of-pairs format.
  function getSeatsFromCart(eventId, cart) {
    if (!cart || !cart.items || !Array.isArray(cart.items)) return 0;
    const eventIdStr = String(eventId || '');
    let totalSeats = 0;

    function propsMatchEvent(props) {
      if (!props || typeof props !== 'object') return false;
      if (!Array.isArray(props)) {
        const gid = props._event_metaobject_gid;
        const eid = props._event_id ?? props.event_id;
        if (gid != null && String(gid) === eventIdStr) return true;
        if (eid != null && String(eid) === eventIdStr) return true;
        return false;
      }
      for (const entry of props) {
        if (!entry) continue;
        const k = entry[0] ?? entry.name;
        const v = entry[1] ?? entry.value;
        if ((k === '_event_metaobject_gid' || k === '_event_id' || k === 'event_id') && String(v) === eventIdStr) return true;
      }
      return false;
    }

    for (const item of cart.items) {
      if (propsMatchEvent(item.properties)) totalSeats += item.quantity || 0;
    }
    return totalSeats;
  }

  // Helper: Validate capacity before adding to cart
  // Simple toast notification function
  function showToast(message, type = 'error') {
    // Create toast element
    const toast = document.createElement('div');
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'error' ? '#f44336' : '#4caf50'};
      color: white;
      padding: 16px 24px;
      border-radius: 4px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      z-index: 10000;
      font-size: 14px;
      max-width: 400px;
      animation: slideIn 0.3s ease-out;
    `;
    toast.textContent = message;
    
    // Add animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    if (!document.head.querySelector('#workshop-toast-styles')) {
      style.id = 'workshop-toast-styles';
      document.head.appendChild(style);
    }
    
    document.body.appendChild(toast);
    
    // Remove after 4 seconds
    setTimeout(() => {
      toast.style.animation = 'slideOut 0.3s ease-out';
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 4000);
  }

  // Shared capacity message helper. Inputs: R, X (event-level seats in cart), Y (requested add qty).
  // Standard capacity messages: R<=0 sold-out; R>0 and over capacity = "You're trying to add more..." + Only R spot(s) remain + Reduce to R or fewer.
  function buildCapacityResult(remainingCapacity, seatsAlreadyInCart, requestedAddQty) {
    const R = remainingCapacity ?? 0;
    const X = seatsAlreadyInCart ?? 0;
    const Y = requestedAddQty ?? 0;
    const allowedAdditional = Math.max(0, R - X);
    const ok = R > 0 && Y <= allowedAdditional;
    let message = '';
    if (R <= 0) {
      message = 'This workshop is sold out. You already have seats for this workshop in your cart. Remove seats to continue.';
    } else if (Y > allowedAdditional) {
      message = `You're trying to add more seats than the remaining capacity. Only ${R} spot(s) remain. Reduce the total seats for this workshop in your cart to ${R} or fewer.`;
    }
    return { ok, message, inCart: X, requested: Y, remaining: R, allowed: allowedAdditional };
  }

  // Validates capacity. Fetches cart once if not provided; returns cartData for reuse in _workshop_prices update.
  async function validateCapacityBeforeAdd(eventId, requestedAddQty, cartData) {
    const liveApi = window.WorkshopCityEvents;
    if (liveApi && typeof liveApi.validateAddToCart === 'function') {
      try {
        if (typeof liveApi.ensureBookingConfig === 'function') {
          await liveApi.ensureBookingConfig({});
        }
        let selectedCard =
          (eventsRoot && eventsRoot.querySelector('.workshop-event-card.is-selected')) || null;
        if (!selectedCard && document.getElementById('wb-event-list')) {
          selectedCard =
            document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
            document.querySelector('.wb-all__event-card.is-selected');
        }
        if (!selectedCard) {
          selectedCard = document.querySelector('.workshop-event-card.is-selected');
        }
        const remainingFromCard = selectedCard ? getRemainingCapacityFromCard(selectedCard) : null;
        const slotForValidate = {
          gid: eventId,
          id: eventId,
          event_metaobject_gid: (selectedCard && selectedCard.dataset.eventMetaobjectGid) || eventId,
          canonical_event_id: (selectedCard && selectedCard.dataset.eventMetaobjectGid) || eventId,
          status: (selectedCard && selectedCard.dataset.eventStatus) || 'active',
          display_status: selectedCard && selectedCard.dataset.displayStatus ? selectedCard.dataset.displayStatus : undefined,
          capacity_remaining: remainingFromCard != null ? remainingFromCard : undefined,
        };
        const verdict = await liveApi.validateAddToCart(
            slotForValidate,
            requestedAddQty,
            { cart: cartData || undefined, intent: 'add_to_cart' }
          );
          const cart = verdict && verdict.cartData ? verdict.cartData : cartData;
          if (verdict && verdict.allowed === false) {
            const msg =
              verdict.message ||
              'This workshop is no longer available. Please select a different event.';
            showToast(msg);
            return {
              allowed: false,
              remainingCapacity: verdict.capacity_remaining != null ? verdict.capacity_remaining : 0,
              adjustedQuantity: 0,
              abort: true,
              message: msg,
              inCart: verdict.inCart || 0,
              requested: requestedAddQty,
              remaining: verdict.capacity_remaining,
              cartData: cart,
            };
          }
          if (verdict && verdict.allowed === true) {
            const remaining = verdict.capacity_remaining;
            const inCart = verdict.inCart || 0;
            const allowedAdditional =
              remaining != null && Number.isFinite(Number(remaining))
                ? Math.max(0, Number(remaining) - inCart)
                : requestedAddQty;
            if (allowedAdditional < requestedAddQty) {
              const msg =
                verdict.message ||
                `Only ${allowedAdditional} seat(s) can be added for this workshop.`;
              showToast(msg);
              return {
                allowed: allowedAdditional > 0,
                remainingCapacity: remaining,
                adjustedQuantity: allowedAdditional,
                abort: allowedAdditional <= 0,
                message: msg,
                inCart,
                requested: requestedAddQty,
                remaining,
                cartData: cart,
              };
            }
            return {
              allowed: true,
              remainingCapacity: remaining,
              adjustedQuantity: requestedAddQty,
              message: '',
              inCart,
              requested: requestedAddQty,
              remaining,
              event_status: verdict.event_status || verdict.status,
              capacity_as_of: verdict.capacity_as_of || null,
              cartData: cart,
            };
          }
        } catch (e) {
          if (window.__WB_DIAG__) console.warn('Workshop: server validate failed', e);
          const CFG = window.WorkshopBookingConfig || window.WorkshopCityConfig;
          if (CFG && typeof CFG.verifySoftMode === 'function' && CFG.verifySoftMode()) {
            return {
              allowed: true,
              remainingCapacity: null,
              adjustedQuantity: requestedAddQty,
              message: '',
              cartData: cartData,
            };
          }
          showToast('We could not verify workshop availability. Please try again.');
          return {
            allowed: false,
            remainingCapacity: 0,
            adjustedQuantity: 0,
            abort: true,
            message: 'We could not verify workshop availability. Please try again.',
            cartData: cartData,
          };
        }
    }

    const root = (window.Shopify?.routes?.root || '/');
    let cart = cartData;
    if (!cart) {
      try {
        const res = await fetch(root + 'cart.js');
        cart = res.ok ? await res.json().catch(function() { return null; }) : null;
      } catch (e) {
        if (window.__WB_DIAG__) console.warn('Workshop: Failed to fetch cart', e);
        cart = null;
      }
    }

    let selectedCard = document.querySelector('.workshop-event-card.is-selected');
    if (!selectedCard && document.getElementById('wb-event-list')) {
      selectedCard =
        document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
        document.querySelector('.wb-all__event-card.is-selected');
    }
    if (!selectedCard) {
      if (liveApi && typeof liveApi.validateAddToCart === 'function') {
        try {
          const slotForValidate = {
            gid: eventId,
            id: eventId,
            event_metaobject_gid: eventId,
            canonical_event_id: eventId,
          };
          const verdict = await liveApi.validateAddToCart(
            slotForValidate,
            requestedAddQty,
            { cart: cartData || undefined, intent: 'add_to_cart' }
          );
          const cart = verdict && verdict.cartData ? verdict.cartData : cartData;
          if (verdict && verdict.allowed === false) {
            const msg =
              verdict.message ||
              'This workshop is no longer available. Please select a different event.';
            showToast(msg);
            return {
              allowed: false,
              remainingCapacity: verdict.capacity_remaining != null ? verdict.capacity_remaining : 0,
              adjustedQuantity: 0,
              abort: true,
              message: msg,
              cartData: cart,
            };
          }
          if (verdict && verdict.allowed === true) {
            return {
              allowed: true,
              remainingCapacity: verdict.capacity_remaining,
              adjustedQuantity: requestedAddQty,
              message: '',
              cartData: cart,
            };
          }
        } catch (e) {
          if (window.__WB_DIAG__) console.warn('Workshop: server validate failed (no card)', e);
        }
      }
      return { allowed: true, remainingCapacity: null, adjustedQuantity: requestedAddQty, message: '', cartData: cart };
    }
    const remainingCapacity = getRemainingCapacityFromCard(selectedCard);
    if (remainingCapacity == null && selectedCard.classList && selectedCard.classList.contains('wb-all__event-card')) {
      return { allowed: true, remainingCapacity: null, adjustedQuantity: requestedAddQty, message: '', cartData: cart };
    }
    const seatsAlreadyInCart = getSeatsFromCart(eventId, cart);
    const res = buildCapacityResult(remainingCapacity, seatsAlreadyInCart, requestedAddQty);

    if (res.remaining <= 0) {
      showToast(res.message);
      return { allowed: false, remainingCapacity: 0, adjustedQuantity: 0, abort: true, message: res.message, inCart: res.inCart, requested: res.requested, remaining: res.remaining, allowed: res.allowed, cartData: cart };
    }
    if (!res.ok) {
      showToast(res.message);
      return {
        allowed: false,
        remainingCapacity: res.remaining,
        adjustedQuantity: res.allowed <= 0 ? 0 : res.allowed,
        abort: res.allowed <= 0,
        message: res.message,
        inCart: res.inCart,
        requested: res.requested,
        remaining: res.remaining,
        allowed: res.allowed,
        cartData: cart
      };
    }
    return { allowed: true, remainingCapacity: res.remaining, adjustedQuantity: requestedAddQty, message: '', cartData: cart };
  }

  /**
   * Global __WORKSHOP_SELECTION__ can be cleared or out of sync (multi-init, filters, other scripts).
   * If user has a visible selected event card, rebuild selection from DOM so Add to Cart / Book Now still work.
   */
  function repairWorkshopSelectionFromDomIfNeeded() {
    var sel = window.__WORKSHOP_SELECTION__;
    var existing = sel && sel.eventId != null ? String(sel.eventId).trim() : '';
    if (existing) return;

    var card =
      document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
      document.querySelector('.wb-all__event-card.is-selected') ||
      document.querySelector('.workshop-event-card.is-selected');
    if (!card) return;

    var eventId =
      (card.dataset.eventMetaobjectGid || card.dataset.eventId || (card.getAttribute && card.getAttribute('data-event-id')) || '')
        .toString()
        .trim();
    if (!eventId) return;

    window.__WORKSHOP_SELECTION__ = {
      eventId: eventId,
      eventHandle: ((card.dataset.eventHandle || (card.getAttribute && card.getAttribute('data-event-handle')) || '').toString()).trim(),
      city: ((card.dataset.city || (card.getAttribute && card.getAttribute('data-city')) || '').toString()).trim(),
      state: ((card.dataset.state || (card.getAttribute && card.getAttribute('data-state')) || '').toString()).trim(),
      venue: ((card.dataset.venueName || (card.getAttribute && card.getAttribute('data-venue-name')) || '').toString()).trim(),
      datetime: ((card.getAttribute && card.getAttribute('data-datetime')) || '').toString().trim()
    };
    if (selectedEventIdInput) selectedEventIdInput.value = eventId;
  }

  // Shared function to add workshop item to cart (plain-cart: add only, no merge/change/update)
  async function addWorkshopToCart(redirectToCheckout = false) {
    if (window.__WORKSHOP_ADDING_TO_CART__) return false;

    repairWorkshopSelectionFromDomIfNeeded();

    // Read selection from global state (possibly repaired from .is-selected card above)
    const selection = window.__WORKSHOP_SELECTION__;
    const eventIdStr = selection && selection.eventId != null ? String(selection.eventId).trim() : '';
    if (!selection || !eventIdStr) {
      alert('Please select an event before adding to cart.');
      return false;
    }

    const eventId = eventIdStr;
    const variantId = variantSelect ? variantSelect.value : '';
    if (!variantId) {
      alert('Please select a variant before adding to cart.');
      return false;
    }

    var eidMatch = String(eventId);
    let selectedCard = null;
    if (eventsRoot) {
      if (typeof CSS !== 'undefined' && CSS.escape) {
        try {
          selectedCard = eventsRoot.querySelector('.workshop-event-card[data-event-id="' + CSS.escape(eidMatch) + '"]');
        } catch (e) {}
      }
      if (!selectedCard) {
        var slotEls = eventsRoot.querySelectorAll('.workshop-event-card[data-event-id]');
        for (var si = 0; si < slotEls.length; si++) {
          if ((slotEls[si].getAttribute('data-event-id') || '').trim() === eidMatch) {
            selectedCard = slotEls[si];
            break;
          }
        }
      }
    }
    if (!selectedCard && document.getElementById('wb-event-list')) {
      var listWa = document.querySelectorAll('#wb-event-list .wb-all__event-card[data-event-id]');
      for (var wi = 0; wi < listWa.length; wi++) {
        if ((listWa[wi].getAttribute('data-event-id') || '').trim() === eidMatch) {
          selectedCard = listWa[wi];
          break;
        }
      }
    }
    if (!selectedCard && selection.eventHandle) {
      // Selection from workshop-events-ui (App Proxy flow); no card in eventsRoot
      selectedCard = null;
    }
    if (!selectedCard && !selection.eventHandle) {
      alert('Selected event not found. Please try again.');
      return false;
    }

    if (selectedCard && wbIsEventSoldOut(selectedCard)) {
      showSoldOutCapacityModal();
      return false;
    }
    if (selectedCard && !wbIsEventBookable(selectedCard)) {
      alert('This session is not available. Please choose another time.');
      return false;
    }

    // CRITICAL FIX: Resolve price FRESH on every add-to-cart to prevent price leakage
    // Do NOT read from dataset.resolvedPriceCents which may be stale
    const basePriceCents = getSelectedVariantPriceCents();
    if (!basePriceCents || Number.isNaN(basePriceCents)) {
      alert('Unable to determine base price. Please refresh and try again.');
      return false;
    }

    // Use selection state (from dataset attributes or workshop:event-selected detail)
    const state = selection.state || (selectedCard && selectedCard.dataset.state) || '';
    const city = selection.city || (selectedCard && selectedCard.dataset.city) || '';
    const venueName = selection.venue || (selectedCard && selectedCard.dataset.venueName) || '';

    // CRITICAL: Resolve price ONLY on Add to Cart (fresh resolution)
    const cityKey = (selectedCard && selectedCard.dataset.cityKey) ? String(selectedCard.dataset.cityKey).trim() : '';
    const venueHandle = (selectedCard && selectedCard.dataset.venueHandle) ? String(selectedCard.dataset.venueHandle).trim() : '';
    const resolvedCents = resolvePriceCents({
      basePriceCents: basePriceCents,
      eventId: eventId,
      state: state,
      city: city,
      cityKey: cityKey,
      venueName: venueName,
      venueHandle: venueHandle,
      variantId: variantId,
      workshopId: booking?.dataset?.productId,
    });

    if (!Number.isFinite(resolvedCents) || resolvedCents <= 0) {
      alert('Unable to determine price. Please refresh and try again.');
      return false;
    }

    // Get event handle from card or selection (must be metaobject handle, never numeric event_id)
    // CRITICAL: Block add-to-cart if handle is missing or numeric
    const datasetEventHandle = (selectedCard && selectedCard.dataset.eventHandle) || selection.eventHandle || '';
    const eventHandle = datasetEventHandle;
    const looksNumeric = /^\d+$/.test(eventHandle);
    
    if (!eventHandle || looksNumeric || eventHandle === String(eventId)) {
      const errorMsg = 'This workshop event is not available for booking. Please select a different event.';
      alert(errorMsg);
      if (window.__WB_DIAG__) {
        console.error('[Workshop] Add to cart blocked - invalid event_handle:', {
          eventHandle: eventHandle,
          eventId: eventId,
          looksNumeric: looksNumeric,
          reason: !eventHandle ? 'missing' : (looksNumeric ? 'numeric' : 'equals_event_id')
        });
      }
      return false;
    }

    if (window.__WB_DIAG__) {
      console.log('[Workshop] Add to cart - event handle validation:', {
        eventId: eventId,
        eventHandle: eventHandle,
        datasetEventHandle: datasetEventHandle
      });
    }

    // Build display properties (for cart/checkout UI) from selection state
    const displayCity = state ? `${city}, ${state}` : city;
    const displayVenue = venueName;
    const displayDatetime = selection.datetime || '';
    const bookingDetailsVisible = `${displayCity || ''}${displayVenue ? ` — ${displayVenue}` : ''}${displayDatetime ? ` · ${displayDatetime}` : ''}`.trim();
    // Prefer event object on the slot button; dataset is a render-time copy.
    const venueContact = (function pickVenueContact(card) {
      if (!card) return { address: '', phone: '', hours: '' };
      var ev = card._wbEv && typeof card._wbEv === 'object' ? card._wbEv : null;
      var venueEl = typeof card.closest === 'function' ? card.closest('.wb-venue-card') : null;
      var venue = venueEl && venueEl._wbVenue && typeof venueEl._wbVenue === 'object' ? venueEl._wbVenue : null;
      function firstStr() {
        for (var i = 0; i < arguments.length; i++) {
          var s = arguments[i] == null ? '' : String(arguments[i]).trim();
          if (s) return s;
        }
        return '';
      }
      return {
        address: firstStr(
          ev && ev.venue_address,
          ev && ev.address,
          card.dataset && card.dataset.venueAddress,
          venue && venue.venue_address,
          venue && venue.address
        ),
        phone: firstStr(
          ev && ev.venue_phone,
          ev && ev.phone,
          card.dataset && card.dataset.venuePhone,
          venue && venue.venue_phone,
          venue && venue.phone
        ),
        hours: firstStr(
          ev && ev.venue_work_hours,
          ev && ev.work_hours,
          card.dataset && card.dataset.venueWorkHours,
          venue && venue.venue_work_hours,
          venue && venue.work_hours
        )
      };
    })(selectedCard);

    // Get quantity from input (default 1)
    const quantityInput = bookingBox ? bookingBox.querySelector('[data-workshop-quantity]') : null;
    let quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;

    const capacityCheck = await validateCapacityBeforeAdd(eventId, quantity);
    
    // If capacity check failed and we should abort, return early
    if (capacityCheck.abort === true) {
      return false;
    }
    
    // If capacity check failed but we can adjust quantity, use adjusted quantity
    if (!capacityCheck.allowed && capacityCheck.adjustedQuantity > 0) {
      quantity = capacityCheck.adjustedQuantity;
      // Update quantity input to reflect adjusted value
      if (quantityInput) {
        quantityInput.value = quantity;
      }
    } else if (!capacityCheck.allowed) {
      // Should not happen if logic is correct, but fail-safe
      return false;
    }

    // Line item properties — Cart Transform only uses _workshop and _resolved_price*
    // _unique base: variantId:eventId; buildCartAddPayload adds :seat:carrier + stack when qty≥2
    let capacityRemaining = null;
    const capRaw =
      selectedCard?.dataset.capacityRemaining ||
      selectedCard?.getAttribute('data-capacity-remaining') ||
      null;
    if (capRaw != null) {
      const n = Number(capRaw);
      if (Number.isFinite(n) && n >= 0) {
        capacityRemaining = String(n);
      }
    }

    const uniqueId = `${variantId}:${eventId}`;
    const centsStr = String(resolvedCents ?? '').trim();
    const validCents = /^[0-9]+$/.test(centsStr) && parseInt(centsStr, 10) > 0;
    // Line item properties: Shopify maps these to cart line attributes for Cart Transform
    let properties = {
      _workshop: "true",
      _event_id: eventId,
      _event_metaobject_gid: selectedCard && selectedCard.dataset.eventMetaobjectGid ? String(selectedCard.dataset.eventMetaobjectGid) : eventId,
      _event_handle: eventHandle,
      _display_city: displayCity,
      _display_venue: displayVenue,
      _display_datetime: displayDatetime,
      _unique: uniqueId,
      _is_workshop: "1",
      "Booking Details": bookingDetailsVisible
    };
    // Hidden in cart/checkout (_); persist on order line for email/admin
    if (venueContact.address) properties._venue_address = venueContact.address;
    if (venueContact.phone) properties._venue_phone = venueContact.phone;
    if (venueContact.hours) properties._venue_hours = venueContact.hours;
    if (validCents) {
      properties._resolved_price_cents = centsStr;
      properties._resolved_price = centsStr;
    } else {
      if (window.__WB_DIAG__) console.warn('[Workshop] Missing/invalid resolved cents', { resolvedCents, variantId, eventId });
    }
    if (capacityRemaining !== null) {
      properties._capacity_remaining = capacityRemaining;
      properties._capacity_source = 'metaobject_dom';
    }

    var validationSlot = {
      gid: eventId,
      status: selectedCard && selectedCard.dataset.eventStatus ? selectedCard.dataset.eventStatus : 'active',
      capacity_remaining: capacityRemaining != null ? Number(capacityRemaining) : null,
      capacity_as_of: capacityCheck && capacityCheck.capacity_as_of ? capacityCheck.capacity_as_of : null,
    };
    if (window.WorkshopCityFlow && typeof window.WorkshopCityFlow.appendCartValidationProperties === 'function') {
      if (capacityCheck && capacityCheck.remaining != null) {
        validationSlot.capacity_remaining = capacityCheck.remaining;
      }
      if (capacityCheck && capacityCheck.event_status) {
        validationSlot.status = capacityCheck.event_status;
      }
      properties = window.WorkshopCityFlow.appendCartValidationProperties(validationSlot, properties);
    } else if (capacityCheck && capacityCheck.event_status) {
      properties._event_status = String(capacityCheck.event_status);
    }

    // Hard guard: prevent duplicate add within 1s (same event + variant + quantity)
    var addLockAddon = addonSelection();
    var addLockAddonQty = (addLockAddon && addLockAddon.selected) ? Math.max(0, parseInt(String(addLockAddon.quantity || 0), 10) || 0) : 0;
    var addLockKey = eventId + '|' + variantId + '|' + quantity + '|' + addLockAddonQty;
    var lock = window.__WB_ADD_LOCK__;
    if (lock && (Date.now() - lock.ts) < 1000 && lock.key === addLockKey) {
      if (window.__WB_DIAG__) console.warn('[Workshop] Duplicate add blocked (lock)', { key: addLockKey });
      return false;
    }
    window.__WB_ADD_LOCK__ = { key: addLockKey, ts: Date.now() };

    window.__WORKSHOP_ADDING_TO_CART__ = true;
    let responseData;
    try {
      if (window.__WB_DIAG__) console.log('[Workshop] REQUEST START add to cart', { eventId: eventId, variantId: variantId, quantity: quantity });
      const sectionsToRender = window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')
        ? window.Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
        : [];
      const root = (window.Shopify?.routes?.root || '/');
      var addonItems = [];
      var addon = addonSelection();
      if (addon.selected && addon.variantId && Number(addon.quantity) > 0) {
        var addonQty = Math.max(0, parseInt(String(addon.quantity || 0), 10) || 0);
        addonItems.push({
          id: addon.variantId,
          quantity: addonQty,
          properties: {
            _workshop_addon: 'true',
            _addon_for_event_id: eventId,
            _addon_for_variant_id: variantId,
            _addon_title: addon.title
          }
        });
      }
      const payload = await buildCartAddPayload(variantId, quantity, properties, sectionsToRender, addonItems);
      const endpoint = root + 'cart/add.js';
      if (window.__WB_DIAG__) console.log('[Workshop Cart] Add payload:', JSON.stringify({ items: payload.items }));

      const addRes = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      responseData = await addRes.json().catch(() => ({}));
      if (!addRes.ok || responseData?.status === 422) {
        const desc = (responseData && responseData.description) ? String(responseData.description) : '';
        const msg = (capacityCheck && capacityCheck.allowed === false && capacityCheck.message)
          ? capacityCheck.message
          : (desc || 'Unable to add to cart. Please try again.');
        alert(msg);
        return false;
      }

      try {
        if (
          window.WorkshopCityCartLive &&
          typeof window.WorkshopCityCartLive.splitMergedWorkshopLines === 'function'
        ) {
          await window.WorkshopCityCartLive.splitMergedWorkshopLines();
        }
      } catch (_) {}

      if (validCents && capacityCheck.cartData) {
        try {
          var cartData = capacityCheck.cartData;
          var prices = {};
          try {
            if (cartData.attributes && cartData.attributes._workshop_prices) {
              prices = JSON.parse(cartData.attributes._workshop_prices);
            }
          } catch (_) {}
          var afterCart = null;
          try {
            var afterRes = await fetch(root + 'cart.js', { credentials: 'same-origin' });
            if (afterRes.ok) afterCart = await afterRes.json();
          } catch (_) {}
          var priceItems = (afterCart && afterCart.items) || (cartData.items || []);
          var priceEventId = String(eventId);
          var priceVariantId = String(variantId);
          priceItems.forEach(function (it) {
            if (!it || !it.properties) return;
            var eid = String(it.properties._event_metaobject_gid || it.properties._event_id || '');
            var vid = String(it.variant_id || it.id || '');
            if (eid !== priceEventId || vid !== priceVariantId) return;
            var u = it.properties._unique;
            if (u) prices[u] = centsStr;
          });
          var keep = {};
          priceItems.forEach(function (it) {
            var u = it.properties && it.properties._unique;
            if (!u && it.properties && it.properties._event_metaobject_gid) {
              u = (it.variant_id || it.id) + ':' + it.properties._event_metaobject_gid;
            }
            if (u && prices[u] != null) keep[u] = prices[u];
          });
          await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _workshop_prices: JSON.stringify(keep) } })
          });
        } catch (attrErr) {
          if (window.__WB_DIAG__) console.warn('[Workshop] cart.attributes update failed', attrErr);
        }
      }

      if (responseData.sections && window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').reRenderSections(responseData.sections);
      }
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span')?.innerHTML || '0');
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

      if (typeof window.__WB_closeWorkshopSheet === 'function') {
        try {
          window.__WB_closeWorkshopSheet();
          wbCloseMobilePreview();
        } catch (closeErr) {}
      }

      if (redirectToCheckout) return true;

      // Workshop product mobile: after successful add-to-cart, close popup panel.
      wbCloseStandaloneMobilePanel();

      // Open theme cart drawer: dispatch ajaxProduct:added (theme.CartDrawer listens for this)
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: responseData } }));
      // Fallback: direct cart:open event
      document.dispatchEvent(new CustomEvent('cart:open'));
      // Some themes repaint after cart events; close once more to ensure sheet stays closed.
      setTimeout(wbCloseStandaloneMobilePanel, 60);
      // Alpine mini-cart fallback
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
        if (!window.Alpine.store('xCartNoti') || !window.Alpine.store('xCartNoti').enable) {
          window.Alpine.store('xMiniCart').openCart();
        }
      }
      return true;
    } catch (err) {
      if (window.__WB_DIAG__) console.error('Workshop booking error:', err);
      const msg = (capacityCheck && capacityCheck.allowed === false && capacityCheck.message)
        ? capacityCheck.message
        : 'Unable to add to cart. Please try again.';
      alert(msg);
      return false;
    } finally {
      window.__WORKSHOP_ADDING_TO_CART__ = false;
      window.__WB_ADD_LOCK__ = null;
    }
  }

  function restoreButtonState(btn, text, clearStyles) {
    if (!btn) return;
    btn.disabled = false;
    btn.textContent = text;
    if (clearStyles) {
      btn.style.backgroundColor = '';
      btn.style.color = '';
      btn.style.cursor = '';
    }
  }

  // Book Now action: add to cart and redirect to checkout/cart (bind once per button)
  if (bookNowBtn && !bookNowBtn.dataset.wbBound) {
    bookNowBtn.dataset.wbBound = '1';
    bookNowBtn.addEventListener('click', async (e) => {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var factsOnBookNow = wstGetCurrentBookingFacts();
      if (factsOnBookNow && factsOnBookNow.venueName && factsOnBookNow.dateLabel && factsOnBookNow.timeLabel && factsOnBookNow.variantName) {
        wstUpdate(
          7,
          wstValuesWithQty(
            factsOnBookNow.venueName,
            factsOnBookNow.dateLabel,
            factsOnBookNow.timeLabel,
            factsOnBookNow.variantName,
            factsOnBookNow.qtyLabel || '',
            factsOnBookNow.extrasName || 'None'
          )
        );
      }
      const originalText = bookNowBtn.textContent;
      bookNowBtn.disabled = true;
      bookNowBtn.textContent = 'Booking...';

      try {
        const success = await addWorkshopToCart(true);
        if (success) {
          window.location.href = '/cart';
          return;
        }
      } catch (_) {}
      restoreButtonState(bookNowBtn, originalText, true);
    });
  }

  if (addToCartBtn && !addToCartBtn.dataset.wbBound) {
    addToCartBtn.dataset.wbBound = '1';
    addToCartBtn.addEventListener('click', async (e) => {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var factsOnAdd = wstGetCurrentBookingFacts();
      if (factsOnAdd && factsOnAdd.venueName && factsOnAdd.dateLabel && factsOnAdd.timeLabel && factsOnAdd.variantName) {
        wstUpdate(
          7,
          wstValuesWithQty(
            factsOnAdd.venueName,
            factsOnAdd.dateLabel,
            factsOnAdd.timeLabel,
            factsOnAdd.variantName,
            factsOnAdd.qtyLabel || '',
            factsOnAdd.extrasName || 'None'
          )
        );
      }
      const originalText = addToCartBtn.textContent;
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      try {
        const success = await addWorkshopToCart(false);
        if (success) {
          addToCartBtn.textContent = 'Added';
          setTimeout(() => restoreButtonState(addToCartBtn, originalText, true), 1500);
          return;
        }
      } catch (_) {}
      restoreButtonState(addToCartBtn, originalText, true);
    });
  }

  /**
   * "Book a workshop" list page: event cards live in #wb-event-list; the booking UI is cloned into #wb-sheet-body.
   * Mirror venue-card selection into the sheet (summary, capacity ring, variant, resolved price, CTA state).
   */
  function tryHydrateWbAllListSelection() {
    if (!booking || !booking.closest || !booking.closest('#wb-sheet-body')) return;
    var listCard =
      document.querySelector('#wb-event-list .wb-all__event-card.is-selected') ||
      document.querySelector('.wb-all__event-card.is-selected');
    if (!listCard) return;
    try {
      setEventSelectionFromCard(listCard);
    } catch (err) {
      if (DEV_MODE) console.warn('[WB] tryHydrateWbAllListSelection', err);
    }
  }

  window.__WB_onListCardUpdated = function (card) {
    try {
      if (!booking || !booking.closest || !booking.closest('#wb-sheet-body')) return;
      if (!card || !card.classList || !card.classList.contains('wb-all__event-card') || !card.classList.contains('is-selected')) return;
      setEventSelectionFromCard(card);
    } catch (e) {}
  };

  applyFilters();

  tryHydrateWbAllListSelection();
  if (booking.closest && booking.closest('#wb-sheet-body')) {
    if (useLocationFirst && typeof setWbState === 'function') {
      setWbState(2);
    }
    validateSeatSelection();
  }

  var placeEl = document.querySelector('#workshop-location-place-autocomplete,[data-workshop-place-autocomplete],gmp-place-autocomplete');
  if (placeEl) {
    ensurePlaceListeners(placeEl);
    if (typeof S.startPlaceInputWatcher === "function") S.startPlaceInputWatcher(placeEl);
  }
  ensureDocPlaceListeners();

    }
  };
})(typeof window !== "undefined" ? window : this);
